import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearCommAutomobileDriverInfo,
  fetchCommAutomobileDriverListAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoDriver/commAutoDriverActions";

export const useCommAutoPolicyDriverInfo = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const Driver = useSelector(
    (storeState: IStoreState) =>
      storeState.commAuto.driver.driverInformation.driversList
  );

  const driverDropDown = React.useMemo(() => {
    return Driver.map((item) => {
      return {
        label: `${item.driver_number || "--"} (Driver Name: ${
          item.driver_name || "N/A"
        } )`,
        value: item.driver_number || "",
      };
    });
  }, [Driver]);

  const refreshData = () => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileDriverListAsync(Number(customerPolicyId)));
    }
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileDriverListAsync(Number(customerPolicyId)));
    }
    return () => {
      dispatch(clearCommAutomobileDriverInfo());
    };
  }, [customerPolicyId]);

  return { driverDropDown, driverList: Driver, refreshData };
};
